import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=7ae412d0&scoped=true&"
import script from "./Live.vue?vue&type=script&lang=ts&"
export * from "./Live.vue?vue&type=script&lang=ts&"
import style0 from "./Live.vue?vue&type=style&index=0&id=7ae412d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae412d0",
  null
  
)

export default component.exports